import Stack from "@mui/material/Stack";
import LoadingButton from "@mui/lab/LoadingButton";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import {
  CircularProgress,
  FormControlLabel,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  table: {
    // minWidth: 650,
    "& .MuiTableCell-root": {
      border: "1px solid",
    },
  },
  particular: {
    // minWidth: "250px",
  },
});

const ChangeStatus = ({ value, onClose, handleSubmit }) => {
  const [productArr, setProductArr] = useState(value?.products ?? []);

  const [checked, setChecked] = useState("Process");
  const classes = useStyles();

  const validationSchema = Yup.object({
    // status: Yup.string().required("Please enter vendor"),
    // file: Yup.mixed().required("A file is required"),
  });

  const handleChangeQty = (index, value) => {
    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
      return;
    }
    let productValue = [...productArr];
    const remaining = Number(productValue[index].remainingQty) || 0;
    const safeValue =
      numericValue < 0
        ? 0
        : numericValue > remaining
        ? remaining
        : numericValue;
    productValue[index] = { ...productValue[index], newQuantity: safeValue };
    setProductArr(productValue);
  };

  return (
    <>
      <Formik
        initialValues={{
          status: "",
          files: null,
        }}
        validationSchema={validationSchema}
        onSubmit={(data, { setSubmitting }) => {
          data.status = checked;
          data.orderId = value._id;
          data.product = [];
          productArr?.forEach((val) => {
            if (val?.newQuantity && val?.newQuantity !== 0) {
              data.product.push({
                productId: val?.productId,
                variantId: val?.variantId,
                quantity: +val.newQuantity,
              });
            }
          });
          setSubmitting(true);
          setTimeout(() => {
            handleSubmit(data);
            setSubmitting(false);
          }, 1500);
        }}
      >
        {({ isSubmitting, errors, setFieldValue }) => (
          <Form>
            <Grid container spacing={2} mb={4}>
              <Grid item sm={12} xs={12}>
                <FormControl>
                  <FormLabel id="demo-row-radio-buttons-group-label">
                    Status
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue={checked}
                  >
                    <FormControlLabel
                      value="Process"
                      control={
                        <Radio onClick={(e) => setChecked(e.target.value)} />
                      }
                      label="Process"
                    />
                    <FormControlLabel
                      value="Partial"
                      control={
                        <Radio onClick={(e) => setChecked(e.target.value)} />
                      }
                      label="Partial"
                    />
                    <FormControlLabel
                      value="Complete"
                      control={
                        <Radio onClick={(e) => setChecked(e.target.value)} />
                      }
                      label="Complete"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {checked === "Partial" && (
                <Grid item xs={12} sm={12}>
                  <TableContainer component={Paper}>
                    <Table
                      // sx={{ minWidth: 650 }}
                      size="small"
                      aria-label="a dense table"
                      className={`${classes?.table} partial-table`}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>Sr. No.</TableCell>
                          <TableCell>Product</TableCell>
                          <TableCell>Variant</TableCell>
                          {/* <TableCell>Remaining Qty</TableCell> */}
                          <TableCell>Qty</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {productArr?.map((item, index) => {
                          return (
                            <TableRow>
                              <TableCell>{index + 1}</TableCell>
                              <TableCell>{item?.productId?.name}</TableCell>
                              <TableCell>{item?.variantId?.name}</TableCell>
                              <TableCell>
                                <TextField
                                  type="text"
                                  placeholder="Qty"
                                  fullWidth
                                  // defaultValue={item?.remainingQty}
                                  value={item?.newQuantity ?? ""}
                                  size="small"
                                  onChange={(evt) =>
                                    handleChangeQty(index, evt.target.value)
                                  }
                                  error={
                                    errors?.products?.length &&
                                    errors?.products[index]?.quantity
                                  }
                                  helperText={
                                    errors?.products?.length &&
                                    errors?.products[index]?.quantity
                                  }
                                />
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}

              <Grid item sm={12} xs={12}>
                <input
                  type="file"
                  name="files"
                  multiple
                  onChange={(event) => {
                    setFieldValue(
                      "files",
                      Array.from(event.currentTarget.files),
                    );
                  }}
                />
              </Grid>
            </Grid>

            <Stack
              spacing={{ xs: 1, sm: 2 }}
              direction="row"
              justifyContent="center"
            >
              <LoadingButton
                variant="outlined"
                color="secondary"
                onClick={onClose}
                size="small"
                // sx={{ mb: 3 }}
              >
                Cancel
              </LoadingButton>
              <LoadingButton
                type="submit"
                variant="contained"
                size="small"
                sx={{ mb: 3 }}
                loading={isSubmitting}
                loadingIndicator={<CircularProgress size={20} />}
              >
                Save
              </LoadingButton>
            </Stack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default ChangeStatus;
